// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.transcript-item_wrapper__JMCVZ {
  width: 100%;
}
.transcript-item_wrapper__JMCVZ:hover {
    outline: 2px solid var(--primaryColor);
  }
.transcript-item_content__m6kNq {
  cursor: pointer;

  display: flex;
  gap: 10px;
  align-items: flex-start;
  justify-content: space-between;

  width: 100%;
  margin: 0;
  padding: 0;
  padding: 18px 20px;
}

.transcript-item_title__wKTzT {
  font-size: 14px;
  font-weight: 500;
  line-height: 14.63px;
  color: var(--textColor);
  text-align: left;
}

/* Smaller screens / mobile */
.smallScreen .transcript-item_wrapper__JMCVZ:not(:last-child)::after {
    content: '';

    display: block;

    width: 100%;
    height: 1px;

    background: rgba(124, 124, 124, 1);
  }
.smallScreen .transcript-item_description__UcoOv {
    display: none;
  }

.transcript-item_highlightedText__0hoyy {
  padding: 2px;
  border-radius: 2px;
  color: var(--backgroundColor);
  background-color: var(--textColor);
}

.transcript-item_highlightedText__0hoyy.transcript-item_active__Iavpm {
    font-weight: 700;
    color: #ffffff;
    background-color: var(--primaryColor);
  }

@media (forced-colors: active) {
    .transcript-item_highlightedText__0hoyy,.transcript-item_highlightedText__0hoyy.transcript-item_active__Iavpm {
      color: MarkText;
      background: Mark;
    }
    .transcript-item_highlightedText__0hoyy.transcript-item_active__Iavpm {
      border: 1px solid ButtonBorder;
    }
  }
`, "",{"version":3,"sources":["webpack://./src/components/transcript/transcript-item.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AAIb;AAHE;IACE,sCAAsC;EACxC;AAEF;EACE,eAAe;;EAEf,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,8BAA8B;;EAE9B,WAAW;EACX,SAAS;EACT,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,6BAA6B;AAE3B;IACE,WAAW;;IAEX,cAAc;;IAEd,WAAW;IACX,WAAW;;IAEX,kCAAkC;EACpC;AAEA;IACE,aAAa;EACf;;AAGF;EACE,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,kCAAkC;AAkBpC;;AAhBE;IACE,gBAAgB;IAChB,cAAc;IACd,qCAAqC;EACvC;;AAEA;IACE;MAEE,eAAe;MACf,gBAAgB;IAClB;IACA;MACE,8BAA8B;IAChC;EACF","sourcesContent":[".wrapper {\n  width: 100%;\n  &:hover {\n    outline: 2px solid var(--primaryColor);\n  }\n}\n.content {\n  cursor: pointer;\n\n  display: flex;\n  gap: 10px;\n  align-items: flex-start;\n  justify-content: space-between;\n\n  width: 100%;\n  margin: 0;\n  padding: 0;\n  padding: 18px 20px;\n}\n\n.title {\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 14.63px;\n  color: var(--textColor);\n  text-align: left;\n}\n\n/* Smaller screens / mobile */\n:global(.smallScreen) {\n  & .wrapper:not(:last-child)::after {\n    content: '';\n\n    display: block;\n\n    width: 100%;\n    height: 1px;\n\n    background: rgba(124, 124, 124, 1);\n  }\n\n  & .description {\n    display: none;\n  }\n}\n\n.highlightedText {\n  padding: 2px;\n  border-radius: 2px;\n  color: var(--backgroundColor);\n  background-color: var(--textColor);\n\n  &.active {\n    font-weight: 700;\n    color: #ffffff;\n    background-color: var(--primaryColor);\n  }\n\n  @media (forced-colors: active) {\n    &,\n    &.active {\n      color: MarkText;\n      background: Mark;\n    }\n    &.active {\n      border: 1px solid ButtonBorder;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `transcript-item_wrapper__JMCVZ`,
	"content": `transcript-item_content__m6kNq`,
	"title": `transcript-item_title__wKTzT`,
	"description": `transcript-item_description__UcoOv`,
	"highlightedText": `transcript-item_highlightedText__0hoyy`,
	"active": `transcript-item_active__Iavpm`
};
module.exports = ___CSS_LOADER_EXPORT___;
